import React from 'react';
import { PageHeader } from '../components/ui/PageHeader';
import { Card, CardContent } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { FileText, Download } from 'lucide-react';
import { DOCUMENTS } from '../data/constants';
import { toast } from 'sonner';
export function Documents() {
  const handleDownloadClick = (e: React.MouseEvent) => {
    e.preventDefault();
    toast.info('Document bientôt disponible au téléchargement.');
  };
  return <div className="flex flex-col w-full" data-id="element-1085" data-mp="2hy14nvmghgxg">
      <PageHeader title="Documents Utiles" subtitle="Retrouvez ici l'ensemble des documents téléchargeables concernant notre CFA, nos formations et notre démarche qualité." data-id="element-1086" data-mp="2hwzj2x7tdc1h" />

      <div className="py-16 md:py-24 bg-muted relative overflow-hidden" data-id="element-1087" data-mp="280we7jlkuzau">
        <div className="absolute top-0 right-0 w-[400px] h-[400px] bg-primary rounded-full blur-[100px] opacity-10 pointer-events-none" data-id="element-1088" data-mp="230qjtvnxayp2" />
        <div className="container max-w-4xl mx-auto relative z-10" data-id="element-1089" data-mp="1yzf0g7vn79pb">
          <div className="grid gap-6" data-id="element-1090" data-mp="idns1ciesmiy">
            {DOCUMENTS.map(doc => <Card key={doc.id} className="border-none shadow-md hover:shadow-xl hover:-translate-y-1 transition-all duration-300 bg-white group" data-id="element-1091" data-mp="n55qntwymb0r">
                <CardContent className="p-6 md:p-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6" data-id="element-1092" data-mp="dekt89t0vcjf">
                  <div className="flex items-start gap-5" data-id="element-1093" data-mp="115gfkreplfja">
                    <div className="w-14 h-14 bg-lavande rounded-2xl flex items-center justify-center shrink-0 mt-1 sm:mt-0 group-hover:scale-110 transition-transform duration-300" data-id="element-1094" data-mp="163i3pqqzs51m">
                      <FileText className="w-7 h-7 text-brand-orange animate-soft-bounce" data-id="element-1095" data-mp="s6363yql4qyk" />
                    </div>
                    <div data-id="element-1096" data-mp="3cu7pmjx5gpsc">
                      <h3 className="font-extrabold font-heading text-xl text-primary-dark mb-2 group-hover:text-primary transition-colors" data-id="element-1097" data-mp="3ctptroeegdky">
                        {doc.title}
                      </h3>
                      <p className="text-muted-foreground leading-relaxed" data-id="element-1098" data-mp="1nbsqr3ikm91h">
                        {doc.description}
                      </p>
                    </div>
                  </div>
                  <Button variant="outline" className="shrink-0 w-full sm:w-auto border-primary/20 text-primary-dark hover:bg-primary/5 font-semibold py-6 px-6" onClick={handleDownloadClick} data-id="element-1099" data-mp="1dm955q3h412x">
                    <Download className="w-5 h-5 mr-2" data-id="element-1100" data-mp="znj8gbkkg3f3" />
                    Télécharger
                  </Button>
                </CardContent>
              </Card>)}
          </div>
        </div>
      </div>
    </div>;
}